import React, { memo, useMemo, useContext } from 'react';
import { Segment } from 'tea-component';
import Loading from '@gp/components/Loading';
import NoData from "@gp/components/NoData";
// @ts-ignore
import { BarEchart } from '@gp/components/CustomEchart';
import { getEChartOpt, tootipFormatter } from './utils/common';
import { context as Context } from '@gp/components/Context';
import './index.scss';

interface BarEchartConProps {
  [keyName: string]: any;
}

function BarEchartCon(props: BarEchartConProps) {
  const {} = props;

  const {
    loading,
    dataList: data,
    updateTime,
    filter,
    onChange,
  }: HeadcountsContextTypes = useContext(Context) || {};

  const options = useMemo(() => {
    const opt = getEChartOpt(
      data,
      filter?.type,
    );
    return {
      ...opt,
      tooltip: {
        ...opt?.tooltip,
        formatter: tootipFormatter,
      },
    };
  }, [data, filter?.type]);

  return (
    <section className="dbg-studio-overall-details-people-5y-headcounts-bar-content">
      <Segment
        style={{display: 'none'}}
        value={filter?.type}
        options={[
          {text: 'Function', value: '1', disabled: loading && filter?.type !== '1'},
          {text: 'Projects', value: '2', disabled: loading && filter?.type !== '2'},
        ]}
        onChange={onChange}
      />
      {loading ? (<Loading loading style={{height: 260}} />) :
      (!data || !data?.dataList?.length)
        ? (<NoData height={200} constomStyle={{fontSize: 14}} />)
        : (
            <>
              <BarEchart
                options={options}
                // xAxisData={}
                fontSize={12}
                // tootipFormatter={tootipFormatter}
                style={{height: '350px', width: '100%', /* marginTop: 20 */}}
              />
            </>
          )
      }
    </section>
  )
}

BarEchartCon.defaultProps = {
}

export default memo(BarEchartCon);
